import { join } from '@bonnet/next/pathname';

// can only be used within the next js application
// not bonnet/plugins or bonnet/ctx-middleware
export default function getWebPathname(...parts) {
    return join(process.env.BASE_PATH, ...parts);
}
